import React from "react";
import Header from "../ui/Header";
import { NavigationSidebar } from "../ui/NavigationSidebar";

interface MainLayoutProps {
  children: React.ReactNode;
}

const MainLayout: React.FC<MainLayoutProps> = ({ children }) => {
  return (
    <div className="min-h-screen bg-[#f5f5f9]">
      <Header />
      <div className="flex">
        <NavigationSidebar />
        {children}
      </div>
    </div>
  );
};

export default MainLayout;
